import { useState } from 'react'
import ListGroup from 'react-bootstrap/ListGroup';
import Button from 'react-bootstrap/Button';
import IsMobile from '../utils/IsMobile';

export const TeenScaleValue = (props) => {
    const {
        name = '',
        onChange = () => {},
        label = '',
        minLabel = '',
        maxLabel = '',
        defaultValue = null
    } = props

    const isMobile = IsMobile();
    const [value, setValue] = useState(defaultValue && !isNaN(defaultValue) ? parseInt(defaultValue) : null);

    const _onChange = (newValue) => {
        setValue(newValue);
        onChange(newValue);
    }

    const getColorRGB = (i) => {
        const colors = [
            'rgb(215, 25, 33)', 'rgb(215, 25, 33)', 'rgb(215, 25, 33)', 
            'rgb(255, 100, 0)', 'rgb(255, 150, 0)', 'rgb(255, 193, 0)', 
            'rgb(213, 225, 0)', 'rgb(160, 238, 0)', 'rgb(89, 244, 0)',  
            'rgb(0, 212, 65)',  'rgb(0, 128, 0)'                       
        ];
        return colors[i] || 'rgb(211, 211, 211)';
    };
    
    const renderBttns = () => {
        const bttns = Array.from({ length: 11 }, (_, i) => i)
        return bttns.map(i => (
            <div key={i} className="w-100 d-flex flex-column align-items-center">
                {/* ETIQUETA SUPERIOR: Solo en móvil y solo para el número 0 */}
                {isMobile && i === 0 && (
                    <small className="mb-2" style={{ fontWeight: 'bold', color: '#333' }}>
                        {minLabel}
                    </small>
                )}

                <div 
                    className={`${isMobile ? 'w-100 mb-2' : 'flex-fill p-1'}`} 
                    style={{
                        border: value === i ? '4px solid #000' : '4px solid transparent',
                        borderRadius: '10px',
                        boxShadow: value === i ? '0px 4px 10px rgba(0,0,0,0.3)' : 'none',
                        minWidth: !isMobile ? '60px' : 'auto' 
                    }}>
                    <ListGroup.Item className="p-0 border-0 bg-transparent w-100" style={{ borderRadius: '0px'}}>    
                        <Button
                            onClick={() => _onChange(i)}
                            className={`w-100 border-0 ${value === i ? 'active' : ''}`}
                            style={{
                                padding: isMobile ? '12px 0' : '10px 20px', 
                                backgroundColor: getColorRGB(i),
                                fontWeight: 'bold',
                                color: 'white',
                                fontSize: !isMobile ? '1.2rem' : '1rem'
                            }}
                        >
                            {i}
                        </Button>
                    </ListGroup.Item>
                </div>

                {/* ETIQUETA INFERIOR: Solo en móvil y solo para el número 10 */}
                {isMobile && i === 10 && (
                    <small className="mt-1 mb-3" style={{ fontWeight: 'bold', color: '#333' }}>
                        {maxLabel}
                    </small>
                )}
            </div>
        ))
    }

    return (
        <div className='red-background w-100' style={{ marginBottom: '0' }}>
            <div className='my-0'>
                <label className='my-0 d-block text-center font-weight-bold'>{label}</label>
                <input type="hidden" name={name} value={value ?? ""} />
                
                {/* EN DESKTOP mantenemos las etiquetas arriba a los costados */}
                {!isMobile && (
                    <div className="d-flex justify-content-between mb-2 px-1">
                        <small style={{ fontWeight: 'bold' }}>{minLabel}</small>
                        <small style={{ fontWeight: 'bold' }}>{maxLabel}</small>
                    </div>
                )}

                <ListGroup 
                    horizontal={!isMobile} 
                    className={`mb-0 ${isMobile ? 'border-0' : 'd-flex'}`}
                    style={{ background: 'transparent' }}
                >
                    {renderBttns()}
                </ListGroup>
            </div>    
        </div>
    )
}